<template>
  <section class="flex flex-row w-full justify-between">
    <div class="px-8 mt-2">
      <h5>{{ material?.name }}</h5>
      <div class="flex flex-col space-y-3">
        <p class="font-sm capitalize">
          {{
            $t("labels.generic", {
              pt: `Nome do capítulo: ${material?.info.chapter}`,
              en: `Chapter name: ${material?.info.chapter}`,
            })
          }}
        </p>
        <div
          class="flex flex-row gap-3 items-center"
          v-if="typeModalHeader == 'STATS_LEARNING_MAP'"
        >
          <p>
            {{
              $t("labels.generic", {
                pt: `Feedback do material:`,
                en: `Material feedback:`,
              })
            }}
          </p>
          <p :class="`${materialTag.class} `">
            {{ materialTag.name }}
          </p>
          <p v-if="material?.info.skipped">
            {{
              $t("labels.generic", {
                pt: `| Avançou em: ${material?.info.stoppedAt}`,
                en: `| Advanced at: ${material?.info.stoppedAt}`,
              })
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="space-x-2">
      <Button
        class="btn-primary"
        icon="pi pi-chevron-left"
        :disabled="indexMaterial == 0"
        @click="onChooseMaterial(-1)"
      ></Button>
      <Button
        class="btn-primary"
        icon="pi pi-chevron-right"
        @click="onChooseMaterial(1)"
        :disabled="indexMaterial == maxIndexMaterial"
      ></Button>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "headerLearningMapStudent",
  emits: ["onChooseMaterial"],
  props: {
    material: {
      type: Object,
    },
    indexMaterial: {
      type: Number,
    },
    maxIndexMaterial: {
      type: Number,
    },
    typeModalHeader: {
      type: String,
    },
  },
  data() {
    return {
      materialTag: {
        name: "Gostou",
        class: "bg-h-success-200 text-h-success-700 rounded-md p-1",
      },
    };
  },
  mounted() {
    this.setMaterialTagStatus();
  },
  methods: {
    onChooseMaterial(value: number): void {
      this.$emit("onChooseMaterial", value);
    },
    setMaterialTagStatus(): void {
      if (this.material?.info.skipped) {
        this.materialTag.name = "Avançou";
        this.materialTag.class =
          "bg-h-warning-100 text-h-warning-700 rounded-md p-1";
      } else if (this.material?.info.liked) {
        this.materialTag.name = "Gostou";
        this.materialTag.class =
          "bg-h-success-200 text-h-success-700 rounded-md p-1";
      } else if (!this.material?.info.liked) {
        this.materialTag.name = "Não gostou";
        this.materialTag.class =
          "bg-h-error-100 text-h-error-700 rounded-md p-1";
      }
    },
  },
});
</script>
